import { Box } from "@mui/material";
import React from "react";
import CalendarIcon from "../../../../assets/SVG/calendarIcon";
import CompanyIcon from "../../../../assets/SVG/companyIcon";
import DayIcon from "../../../../assets/SVG/dayIcon";
import DescriptionIcon from "../../../../assets/SVG/descriptionIcon";
import FlagIcon from "../../../../assets/SVG/flagIcon";
import Group from "../../../../assets/SVG/group";
import MapMarkerIcon from "../../../../assets/SVG/mapMarkerIcon";
import PhoneIcon2 from "../../../../assets/SVG/phoneIcon2";
import SocialMedia from "../../../../assets/SVG/socialMedia";
import UniversityIcon from "../../../../assets/SVG/universityIcon";
import { LabelInformation } from "../generalInformation";

export default function GroupInformation({
  createdAt,
  platform,
  totalTrips,
  recentTrips,
  lodgment,
  totalMembers,
  groupRegistrationPlace,
  tripDays,
  regionsCount,
  tripFrequency,
  tel,
  pageAddress,
  tripRadius,
  site,
  atlasCode,
  address,
}) {
  const width = "calc(100% / 3 )";
  return (
    <>
      <Box
        sx={{ margin: "auto" }}
        display="flex"
        flexWrap={"wrap"}
        width="calc(100% - 20px )"
      >
        <LabelInformation
          width={width}
          label="سال تاسیس گروه"
          value={createdAt ? createdAt.split("-", 2)[0] : "مهارتی ثبت نشده است"}
        >
          <CalendarIcon />
        </LabelInformation>
        <LabelInformation
          width={width}
          label="پلتفرم"
          value={platform ? platform : "مهارتی ثبت نشده است"}
        >
          <DescriptionIcon />
        </LabelInformation>
        <LabelInformation
          width={width}
          label="تعداد کل اردوها"
          value={totalTrips ? totalTrips : ""}
        >
          <FlagIcon />
        </LabelInformation>
        <LabelInformation
          width={width}
          label=" تعداد اردوهای سال اخیر"
          value={recentTrips ? recentTrips : "مهارتی ثبت نشده است"}
        >
          <FlagIcon />
        </LabelInformation>
        <LabelInformation
          width={width}
          label=" محل استقرار گروه"
          value={
            lodgment
              ? lodgment === "MOSQUE"
                ? "مسجد"
                : lodgment === "OFFICE"
                ? "دفتر خصوصی"
                : lodgment === "UNIVERSITY"
                ? "دانشگاه"
                : lodgment === "BASIJ"
                ? "دفتر بسیج"
                : "مسجد"
              : "مهارتی ثبت نشده است"
          }
        >
          <CompanyIcon />
        </LabelInformation>
        <LabelInformation
          width={width}
          label=" تعداد کل جهادگران"
          value={totalMembers ? totalMembers : "مهارتی ثبت نشده است"}
        >
          <Group color="#9A9A9A" />
        </LabelInformation>
        <LabelInformation
          width={width}
          label=" تعداد کل جهادگران فعال"
          value={totalMembers ? totalMembers : "مهارتی ثبت نشده است"}
        >
          <Group color="#9A9A9A" />
        </LabelInformation>
        <LabelInformation
          width={width}
          label="محل ثبت گروه"
          value={
            groupRegistrationPlace
              ? groupRegistrationPlace === "UNIVERSITY_BASIJ"
                ? "بسیج دانشجویی"
                : groupRegistrationPlace === "MEDICAL_BASIJ"
                ? "بسیج جامعه پزشکی"
                : groupRegistrationPlace === "DISTINCT_BASIJ"
                ? "بسیج محلات"
                : groupRegistrationPlace === "OTHER_BASIJ"
                ? "دیگر بسیج‌ها"
                : groupRegistrationPlace === "COUNTRY_MINISTRY"
                ? "وزارت کشور"
                : groupRegistrationPlace === "MEDICAL_MINISTRY"
                ? "وزارت بهداشت"
                : groupRegistrationPlace === "SEPAH"
                ? "سپاه"
                : "مسجد"
              : "مهارتی ثبت نشده است"
          }
        >
          <UniversityIcon color="#9A9A9A" />
        </LabelInformation>
        <LabelInformation
          width={width}
          label=" تعداد روزهای اردو"
          value={tripDays ? tripDays : "مهارتی ثبت نشده است"}
        >
          <DayIcon color="#9A9A9A" />
        </LabelInformation>
        <LabelInformation
          width={width}
          label=" تعداد کل مناطق"
          value={regionsCount ? regionsCount : "مهارتی ثبت نشده است"}
        >
          <DayIcon color="#9A9A9A" />
        </LabelInformation>
        <LabelInformation
          width={width}
          label="بسامد برگزاری اردوها"
          value={
            tripFrequency
              ? tripFrequency === "ALWAYS"
                ? "دائمی"
                : tripFrequency === "WEEKLY"
                ? "هفتگی"
                : tripFrequency === "MONTHLY"
                ? "ماهانه"
                : tripFrequency === "SEASONAL"
                ? "فصلی"
                : tripFrequency === "TWICE_IN_YEAR"
                ? "دوبار در سال"
                : tripFrequency === "YEARLY"
                ? "سالانه"
                : "سالانه"
              : "مهارتی ثبت نشده است"
          }
        >
          <FlagIcon />
        </LabelInformation>
        <LabelInformation
          width={width}
          label=" شماره تلفن ثابت"
          value={tel ? tel : "مهارتی ثبت نشده است"}
        >
          <PhoneIcon2 color="#9A9A9A" />
        </LabelInformation>
        <LabelInformation
          width={width}
          label="آدرس پیج"
          value={pageAddress ? pageAddress : "مهارتی ثبت نشده است"}
        >
          <SocialMedia color="#9A9A9A" />
        </LabelInformation>
        <LabelInformation
          width={width}
          label="بسامد برگزاری اردوها"
          value={
            tripRadius
              ? tripRadius === "SPECIFIC_POINT"
                ? "در یک نقطه ثابت"
                : tripRadius === "SPECIFIC_DISTINCT"
                ? "در یک محله"
                : tripRadius === "SPECIFIC_CITY"
                ? "در یک شهر"
                : tripRadius === "SPECIFIC_PROVINCE"
                ? "در یک استان"
                : tripRadius === "TWICE_IN_YEAR"
                ? "دوبار در سال"
                : tripRadius === "COUNTRY"
                ? "کشوری"
                : tripRadius === "INTERNATIONAL"
                ? "بین المللی"
                : "بین المللی"
              : "مهارتی ثبت نشده است"
          }
        >
          <FlagIcon />
        </LabelInformation>
        <LabelInformation
          width={width}
          label="آدرس سایت"
          value={site ? site : "مهارتی ثبت نشده است"}
        >
          <SocialMedia color="#9A9A9A" />
        </LabelInformation>
        <LabelInformation
          width={width}
          label="کد اطلس یا شناسه ملی جهادگران"
          value={atlasCode ? atlasCode : ""}
        >
          <DescriptionIcon />
        </LabelInformation>

        <LabelInformation
          width={width}
          label="نشانی پایگاه"
          value={address ? address : "حساسیتی ثبت نشده است"}
        >
          <MapMarkerIcon color="#9A9A9A" />
        </LabelInformation>
      </Box>
    </>
  );
}
